export const DASHBOARD_VIEW = {
  GRID: 'GRID_VIEW',
  LIST: 'LIST_VIEW'
}
